<template>
    <div class="grey lighten-4">
        <v-card v-if="page" fill-height>
            <v-card-text>
                <v-form ref="form">
                    <v-autocomplete
                        v-model="page.widget_ids"
                        :items="widgets"
                        multiple
                        chips
                        :label="'Attach Widgets'"
                        item-text="name"
                        item-value="id"
                        color="primary"
                        class="mt-4"
                        :hint="'Only published widgets will be displayed in the homepage'"
                        persistent-hint
                    >
                        <template v-slot:selection="data">
                            <v-chip
                                close
                                class="chip--select-multi primary--text grey lighten-3"
                                @input="removeSelectedWidget(data.item)"
                            >
                                <v-avatar v-if="data.item.image_url">
                                    <img :src="data.item.image_url" />
                                </v-avatar>
                                {{ data.item.name }}
                            </v-chip>
                        </template>
                        <template v-slot:item="data">
                            <v-list-tile avatar class="d-flex" @click="addSelectedWidget(data.item)">
                                <v-list-tile-avatar v-if="data.item.image_url">
                                    <img :src="data.item.image_url" />
                                </v-list-tile-avatar>
                                <v-list-tile-content>
                                    <v-list-item-subtitle class="grey--text"><small>{{ DEFINES.WIDGETS.TYPES[data.item.type] }}</small></v-list-item-subtitle>
                                    <v-list-tile-title v-html="data.item.name"></v-list-tile-title>
                                </v-list-tile-content>
                            </v-list-tile>
                        </template>
                    </v-autocomplete>
                </v-form>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="pa-3">
                <v-spacer></v-spacer>
                <v-btn color="secondary" dark @click="savePage">Save</v-btn>
            </v-card-actions>  
        </v-card>
    </div>  
</template>

<script>
import DEFINES from "@/defines";
import rules from "@/validation";
export default {
    name:"AdminPageWidgets",
    props: {
        page: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            rules,
            widgets:[]
        };
    },
    created(){
        this.getAllWidgetsFromApi()
    },
    methods:{
        async getAllWidgetsFromApi()
        {
            try {
                let payload = {
                    sorting_order:true
                }
                var response = await this.$store.dispatch("adminWidget/list", payload);
                this.widgets = response.widgets.data;
            } catch (error) {
                this.$store.dispatch("app/showMessage", {
                    message: error.message,
                    color: this.DEFINES.SNACKBAR_ERROR_COLOR,
                });
            }
        },
        savePage(){
            if (!this.$refs.form.validate()) {
                return false;
            }
            this.$emit('onSave', this.page)
        },
        removeSelectedWidget(widget) {
            const index = this.page.widget_ids.indexOf(widget.id);
            if (index >= 0) this.page.widget_ids.splice(index, 1);
        },
        addSelectedWidget(widget){
            // If already there, remove it
            if(this.page.widget_ids.includes(widget.id)){
                return this.removeSelectedWidget(widget);
            }
            this.page.widget_ids.push(widget.id);
        }
    }
}
</script>

<style>

</style>